//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//styles
import {
  HeroSection,
  HeroInner,
  HeroCopy,
  HeroTitle,
  HeroSub,
  HeroTagline,
} from './Hero.styles';

export function Hero({ content }) {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroCopy>
          <HeroTitle>
            {content.title}
            <br />
            <Grad>{content.titleHighlight}</Grad>
          </HeroTitle>
          <HeroSub>{content.copy}</HeroSub>
          {content.tagline && <HeroTagline>{content.tagline}</HeroTagline>}
          <PillLink
            href={content.ctaHref ?? '/contact/#contact-form'}
            className="qlf-btn-1"
          >
            {content.ctaLabel}
          </PillLink>
        </HeroCopy>
      </HeroInner>
    </HeroSection>
  );
}
